<template>
  <v-dialog v-model="isDialogVisible" max-width="1280px">
    <v-card class="pa-8 pa-sm-16 profgram-dialog">
      <v-btn class="button-close ma-4" icon @click="onClose()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <h2 class="text-center">
        {{ editMode ? ($store.getters['auth/isAllowed']('change_professiogram') ? 'Редактирование' : 'Просмотр') : 'Создание'}}
        профессиограммы
      </h2>
      <form @submit.prevent="saveProf" class="mt-6">
        <div class="container">
          <div class="row">
            <div class="col-6">
              <v-text-field label="Название профессии *" outlined dense v-model="editedItem.name"
                @input="$v.editedItem.name.$model = $event, onInput('name')" :error-messages="nameErrors"
              />
            </div>
            <div class="col-6">
              <v-select  v-model="editedItem.owner" :items="customers" label="Владелец"
                :item-text="(item) => (item.first_name || item.last_name ? item.last_name + ' ' + item.first_name : 'имя не задано') +
                                  ' (' + (item.user_role === 'corpclient' ? 'Клиент' : (item.user_role === 'partner' ? 'Партнер' : '')) + ', ' + item.email + ')'"
                item-value="id" outlined dense  :error-messages="ownerErrors" @change="clearError()"
              />
            </div>
          </div>
          <v-divider class="my-2"></v-divider>

          <h3 class="my-2">Выберите раздел</h3>
          <div class="d-flex flex-wrap">
            <v-btn v-if="$store.getters['auth/isAllowed']('add_chapter')" class="mr-3 mb-2 px-2 py-3" outlined @click="showDlgCreateChapter=true">
              Новый раздел
            </v-btn>
            <div v-for="c in chapters" :key="c.id" class="chapter-checkbox mr-3" :class="{ 'chapter-checkbox-active': editedItem.chapters.includes(c.id)}">
              <v-checkbox v-model="editedItem.chapters" @change="$v.$touch()" :label="c.name" :value="c.id" dense hide-details class="mt-0" />
            </div>
          </div>
          <div class="error--text error-msg">{{chapterErrors}} </div>

          <v-divider class="my-2"></v-divider>
          <h3 class="my-2">Психологический тест</h3>
          <ProfPeakPanel :editedItem="editedItem" />

          <v-divider class="mt-8 mb-2"></v-divider>
          <h3 class="my-2">Выберите компетенции</h3>
          <div class="row py-3 mb-2">
            <div class="col-12 col-lg-4 py-0" v-for="chunk in 3" :key="chunk">
              <div v-for="c in competsChunk(chunk-1, 3)" :key="c.id" class="chapter-checkbox"
                :class="{ 'chapter-checkbox-active': editedItem.competences.includes(c.id)}"
              >
                <v-checkbox v-model="editedItem.competences" @change="$v.$touch()" :value="c.id"
                  :label="c.name" dense hide-details class="mt-0" />
              </div>
            </div>
            <div class="error--text error-msg">{{competsErrors}} </div>
          </div>

          <v-expansion-panels>
            <ProfWeightPanel label="Личностный опросник" :value="editedItem.mmil_weight" :errorMessages="weightError"
              @input="editedItem.mmil_weight = $event, checkWeight()" hide-actions
            />
            <ProfWeightPanel label="Логика" :value="editedItem.logic_weight" :errorMessages="weightError"
              @input="editedItem.logic_weight = $event, checkWeight()"
            >
              <v-expansion-panel-content>
                <div class="my-2 scale-wrapper">
                  <div v-for="ls in editedItem.logic_scales" :key="ls.id" class="scale">
                    <h5 class="text-center mb-5 blue--text">{{ls.name}}</h5>
                      <div class="d-flex">
                        <v-text-field label="От" outlined dense class="rank" v-model="ls.min_value" :error-messages="logicError(ls, 'min_value')"
                          @input2="$v.editedItem.logic_verbal.min_value.$model = $event, onInput('name')"
                        />
                        <v-text-field label="До" outlined dense class="rank ml-2" v-model="ls.max_value" :error-messages="logicError(ls, 'max_value')"
                          @input2="$v.editedItem.logic_verbal.max_value.$model = $event, onInput('name')"
                        />
                      </div>
                  </div>
                </div>
              </v-expansion-panel-content>
            </ProfWeightPanel>

            <ProfWeightPanel label="Интересы" :value="editedItem.interests_weight" :errorMessages="weightError"
              @input="editedItem.interests_weight=$event, checkWeight()" :invalid="interestInvalid()"
            >
              <ProfInterestsPanel :editedItem="editedItem" ref="profInterestsPanel"/>
            </ProfWeightPanel>

            <ProfWeightPanel v-for="test in editedItem.constructor_tests" :key="test.code" :errorMessages="weightError"
              :label="test.name" :value="test.weight" @input="test.weight = $event, checkWeight()"
            >
              <ProfConstructorPanel :editedItem="editedItem" :test="test" />
            </ProfWeightPanel>
          </v-expansion-panels>

          <!-- <v-divider class="my-2"></v-divider> -->
          <h3 class="my-2 mt-6">Введите стоимость</h3>
          <v-text-field label="Cтоимость *" outlined dense suffix="₽"
              v-model="editedItem.cost" @input="$v.editedItem.cost.$model = $event, onInput('cost')" :error-messages="costErrors"
          />

          <div v-for="(err, ind) in errors.create" :key="ind" class="error--text">
            <template v-if="!editedItem.hasOwnProperty(err[0])">
              <div v-for="(e, i) in err[1]" :key="i">{{e}}</div>
            </template>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-md-6 mx-auto">
            <v-btn type="submit" class="w-100" color="primary" :loading="loading.create"
              :disabled="loading.create || !$store.getters['auth/isAllowed']('change_professiogram')"
            >
              Сохранить
            </v-btn>
          </div>
        </div>
      </form>
    </v-card>
    <CreateChapterModal v-model="showDlgCreateChapter" @created="chapterCreated"/>
    <ConfirmDialog v-model="showDlgCancel" text="Вы уверены что хотите выйти?<br>
        Все несохраненные данные будут потеряны." okText="Выйти" @action="isDialogVisible = false"
    />
  </v-dialog>
</template>

<script>
/* eslint-disable */
import api from '@/common/api';
import { mapActions, mapGetters } from 'vuex';
import { required, minValue } from 'vuelidate/lib/validators';
import { MESSAGES } from '@/common/constants/errorMessages';
import CreateChapterModal from '@/components/profgrams/CreateChapterModal';
import ConfirmDialog from '@/components/profgrams/ConfirmDialog';
import Spoiler from '@/components/ui/Spoiler';
import ProfPeakPanel from './ProfPeakPanel';
import ProfInterestsPanel from './ProfInterestsPanel';
import ProfWeightPanel from './ProfWeightPanel'
import ProfConstructorPanel from './ProfConstructorPanel'

export default {
  components: {
    CreateChapterModal, ConfirmDialog, Spoiler, ProfPeakPanel, ProfInterestsPanel, ProfWeightPanel, ProfConstructorPanel
  },
  model: {
    editedItem: 'value',
    event: 'input',
  },
  props: {
    value: Boolean,
  },
  data() {
    return {
      calcType: 0,
      calcTypes: [{ id: 0, text: "По пикам" }, { id: 1, text: "По диапазонам" }],
      showDlgCreateChapter: false,
      showDlgCancel: false,
      customers: [],
      weightError: []
    };
  },
  validations: {
    editedItem: {
      name: {
        required,
        isUnique(value) {
          if (value === '' || this.editMode) return true;
          if (this.profs) return !this.profs.find((el) => el.name === value);
          return true;
        },
      },
      owner: { required },
      chapters: { required },
      competences: { required },
      cost: { required, minValue: minValue(1000) },
    },
  },
  watch: {
    async value(val) {
      if (val) {
        this.$v.$reset();
        this.weightError = []
        await this.loadCustomers();
      }
    },

  },
  computed: {
    ...mapGetters({
      loading: 'profgrams/profs/loading',
      errors: 'profgrams/profs/errors',
      chapters: 'profgrams/chapters/items',
      scales: 'profgrams/profs/scales',
      profs: 'profgrams/profs/profs',
      competences: 'profgrams/compets/items',
      competsChunk: 'profgrams/compets/itemsChunk',
      editedItem: 'profgrams/profs/editedItem',
    }),
    editMode() {
      return !!this.editedItem.id;
    },
    nameErrors() {
      return this.validationErrors('name', {
        required: MESSAGES.REQUIRED,
        isUnique: MESSAGES.PROF_ALREADY_EXISTS,
      });
    },
    chapterErrors() {
      return this.validationErrors('chapters', { required: MESSAGES.PROF_CHAPTERS_EMPTY }).join();
    },
    ownerErrors() {
      const errors = [];
      if (!this.$v.editedItem.owner.$dirty) return errors;
      if (!this.$v.editedItem.owner.required) errors.push(MESSAGES.REQUIRED);
      const err = this.errors.create.find(el => el[0]==='owner')
      return err ? err[1] : '';
    },
    competsErrors() {
      return this.validationErrors('competences', { required: MESSAGES.PROF_COMPETS_EMPTY }).join();
    },
    costErrors() {
      return this.validationErrors('cost', { required: MESSAGES.REQUIRED, minValue: MESSAGES.PROF_SUMM });
    },
    isDialogVisible: {
      get() {
        return this.value;
      },
      set(value) {
        if (!value) {
          this.$emit('input', false);
        }
      },
    },
  },
  methods: {
    ...mapActions({
      clearError: 'profgrams/profs/clearError',
      saveAction: 'profgrams/profs/save',
    }),
    interestInvalid() {
      console.log(this.$refs.profInterestsPanel ? this.$refs.profInterestsPanel.$v.$invalid : false)
      return this.$refs.profInterestsPanel ? this.$refs.profInterestsPanel.$v.$invalid: false
      // return this.$refs.profInterestsPanel.$v.
    },
    onClose() {
      if (!this.$store.getters['auth/isAllowed']('change_professiogram')) this.isDialogVisible = false;
      else if (this.$v.$anyDirty) this.showDlgCancel = true;
      else this.isDialogVisible = false;
    },
    onInput() {
      if (this.errors.create.length) this.clearError();
      this.weightError = []
    },
    chapterCreated(chapter) {
      this.editedItem.chapters.push(chapter.id);
    },
    validationErrors(fieldName, validators) {
      const errors = [];
      for (const err of this.errors.create) {
        if (fieldName===err[0]) errors.push(...err[1]);
      }

      if (!this.$v.editedItem[fieldName].$dirty) return errors;
      for (const key in validators) {
        if (!this.$v.editedItem[fieldName][key]) {
          errors.push(validators[key]);
        }
      }
      return errors;
    },
    logicError(ls, field) {
      if (+ls.min_value===0 && +ls.max_value===0) return
      if (+ls.min_value > +ls.max_value)
        return 'Максимальное значение должно быть больше минимального';
      if (+ls[field] > 100 || +ls[field] < 0 )
        return 'Значение должно быть в диапазоне от 0 до 100';
    },
    checkWeight() {
      this.onInput()
      let sum100 = (+this.editedItem.logic_weight) + (+this.editedItem.interests_weight) + (+this.editedItem.mmil_weight)
      sum100 += this.editedItem.constructor_tests.reduce((sum, test) => sum + Number(test.weight), 0);
      if ( sum100 !== 100) {
        this.weightError = ['Сумма весов должна быть равна 100']
        return false
      }
      return true
    },
    saveProf() {
      if (this.loading.create) return;
      if (!this.checkWeight()) return;
      
      this.$v.$touch();

      // console.log(this.$refs)
      this.$refs.profInterestsPanel.$v.$touch()

      if (!this.$v.$invalid && !this.$refs.profInterestsPanel.$v.$invalid) {
        this.saveAction(this.editedItem).then((resp) => {
          if (resp)
            this.$emit('input', false);
        });
      }
    },
    async loadCustomers() {
      try {
        this.customers = await api.get('/users/customers/');
        this.customers = this.customers.sort((a, b) => {
          const aname = a.last_name || a.first_name ? `${a.last_name} ${a.first_name}` : 'Я';
          const bname = b.last_name || b.first_name ? `${b.last_name} ${b.first_name}` : 'Я';
          return aname.localeCompare(bname);
        })
      } catch (err) {
        this.$toast.error('Ошибка при загрузке пользователей', '', { position: 'topRight' });
      }
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/styles/_variables.scss';

.profgram-dialog .scale-wrapper {
  position: relative;
  display: flex;
  flex-wrap: wrap;
}

.profgram-dialog .scale {
  padding: 5px 8px 8px 8px;
  border: 1px solid $color-gray;
  border-radius: 5px;
  width: 200px;
  flex: 200px 0 0;
  margin-right: 20px;
  margin-bottom: 10px;
  .scale-header {
    min-height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.profgram-dialog .error-msg {
  height: 20px;
  font-size: 12px;
  margin-left: 10px;
}
.profgram-dialog .chapter-checkbox {
  border: 1px solid $color-gray;
  border-radius: 4px;
  padding: 2px 10px 4px 8px;
  margin: 0px 8px 8px 0;
}
.profgram-dialog .chapter-checkbox-active {
  border: 1px solid $color-blue;
}

.profgram-dialog .rank-edit {
  width: 80px;
}

</style>
